(function (window) {
	"use strict";
	function definePermissionsHelper() {
		let permissionsHelper = {};
		let localStorageKey = "permissions";
		permissionsHelper.accessType = {
			write: 1,
			read: 2,
			hidden: 3
		};
        permissionsHelper.permissionType = {
            control: 4,
            dataTableAction: 5,
            dataTableColumn: 6
        }
		permissionsHelper.role = {
			salesRep: 3
		};
		let currentRoute = null;

		document.onload = function (){
			console.log("loaded login");
			if(location.pathname === "/Account/Login"){
				sessionStorage.removeItem(localStorageKey);
			}
		};

		permissionsHelper.setCurrentRoute = function (route){
			let path = route.path;
			if(route.params !== null){
				let paramsKeys = Object.keys(route.params)
				if(paramsKeys.length > 0){
					for(let i = 0; i < paramsKeys.length; i++){
						let key = paramsKeys[i];
						let paramValue = route.params[key];
						if(paramValue !== null && paramValue !== ""){
							path = path.replace("/" + paramValue, "");
						}
					}
				}
			}
			currentRoute = path;
		};

		permissionsHelper.checkIfUserHasPermission = function (roleId){
			let permissionsInStorage = sessionStorage.getItem(localStorageKey);
			if(permissionsInStorage === null){
				// get from api
				permissionsHelper.getPermissions(false, false);
			}
			else{
				let permissions = JSON.parse(permissionsInStorage);
				permissions = getPermissionsForCurrentRoute(permissions);
				for(let i = 0; i < permissions.length; i++){
					if(roleId === permissions[i].roleId){
						return true;
					}
				}
			}
			return false;
		}
		//call in app js in mounted
		permissionsHelper.getPermissions = function (callControlsMethod, callDataTableMethod){
			let permissionsInStorage = sessionStorage.getItem(localStorageKey);
			if(permissionsInStorage === null){
				// get permissions and store in local storage
				securityService.getRolePermissions().then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							if(successResponse.data.result !== null){
								sessionStorage.setItem(localStorageKey, JSON.stringify(successResponse.data.result));
								if(callControlsMethod){
									permissionsHelper.setControlsBasedOnPermissions();
								}
								if(callDataTableMethod){
									permissionsHelper.setDataTableActionsBasedOnPermissions();
								}
							}
						}
					},
					errorResponse => {
						console.log("error", errorResponse);
						alert("Unexpected error occurred");
					}
				);
			}
		}

		permissionsHelper.setControlsBasedOnPermissions = function (){
			console.log("currentRoute", currentRoute);
			let elementsOnPage = document.querySelectorAll(".btn, .form-control, .dropdown-item, .form-check-input, .permission-control");
			setControlAndActionButtonAccessBasedOnPermissions(elementsOnPage, true, false);
		};

		permissionsHelper.setDataTableActionsBasedOnPermissions = function (){
			let elementsOnPage = document.querySelectorAll(".dropdown-item");
			let permissionsInStorage = sessionStorage.getItem(localStorageKey);
			if(permissionsInStorage === null){
				// get from api
				permissionsHelper.getPermissions(true, false);
			}
			else{
				let permissions = JSON.parse(permissionsInStorage);
				permissions = getPermissionsForCurrentRoute(permissions);
				for(let i = 0; i < permissions.length; i++){
					for(let j = 0; j < elementsOnPage.length; j++){
						if(elementsOnPage[j].id.startsWith(permissions[i].code)){
							switch(permissions[i].accessType){
								case permissionsHelper.accessType.hidden:
									elementsOnPage[j].classList.add("hide-element");
									break;
								case permissionsHelper.accessType.write:
								case permissionsHelper.accessType.read:
									elementsOnPage[j].classList.remove("hide-element");
									elementsOnPage[j].removeAttribute("disabled");
									break;
								default:
									elementsOnPage[j].classList.remove("hide-element");
									elementsOnPage[j].removeAttribute("disabled");
									break;
							}
						}
					}
				}
			}
		}
        
        permissionsHelper.setTableColumnsBasedOnPermissions = function (tableColumns){
            let permissionsInStorage = sessionStorage.getItem(localStorageKey);
            if(permissionsInStorage === null){
                // get from api
                permissionsHelper.getPermissions(false, true);
                return tableColumns;
            }
            else{
                let permissions = JSON.parse(permissionsInStorage);
                permissions = getPermissionsForCurrentRoute(permissions);
                // filter permissions by permission type dataTableColumn
                permissions = permissions.filter(function(permission){
                    return permission.permissionType === permissionsHelper.permissionType.dataTableColumn;
                });
                if(permissions === null || permissions.length === 0){
                    return tableColumns;
                }
                let newTableColumns = tableColumns.slice(); // create a copy of the original array
                for(let i = 0; i < permissions.length; i++){
                    for(let j = 0; j < tableColumns.length; j++){
                        if(tableColumns[j].id.startsWith(permissions[i].code)){
                            switch(permissions[i].accessType){
                                case permissionsHelper.accessType.hidden:
                                    newTableColumns = newTableColumns.filter(function(column){
                                        return column.id !== tableColumns[j].id;
                                    });
                                    break;
                            }
                        }
                    }
                }
                console.log("newTableColumns", newTableColumns);
                return newTableColumns;
            }
        }

		function getPermissionsForCurrentRoute(permissions){
			let permissionsForRoute = [];
			for(let i = 0; i < permissions.length; i++){
				if(currentRoute === permissions[i].route){
					permissionsForRoute.push(permissions[i]);
				}
			}
			return permissionsForRoute;
		}
		function setControlAndActionButtonAccessBasedOnPermissions(elementsOnPage, callControlsMethod, callDataTableMethod){
			let permissionsInStorage = sessionStorage.getItem(localStorageKey);
			if(permissionsInStorage === null){
				// get from api
				permissionsHelper.getPermissions(callControlsMethod, callDataTableMethod);
			}
			else{
				let permissions = JSON.parse(permissionsInStorage);
				permissions = getPermissionsForCurrentRoute(permissions);
				console.log("permissions", permissions);
				for(let i = 0; i < permissions.length; i++){
					for(let j = 0; j < elementsOnPage.length; j++){
						if(elementsOnPage[j].id.startsWith(permissions[i].code)){
							switch(permissions[i].accessType){
								case permissionsHelper.accessType.hidden:
									elementsOnPage[j].classList.add("hide-element");
									break;
								case permissionsHelper.accessType.write:
								case permissionsHelper.accessType.read:
									elementsOnPage[j].classList.remove("hide-element");
									elementsOnPage[j].removeAttribute("disabled");
									break;
								default:
									elementsOnPage[j].classList.remove("hide-element");
									elementsOnPage[j].removeAttribute("disabled");
									break;
							}
						}
					}
				}
			}
		}

		return permissionsHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (permissionsHelper) === "undefined") {
		window.permissionsHelper = definePermissionsHelper();
	} else {
		console.log("permissionsHelper already defined.");
	}
})(window);